var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderMedications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.37207,
    y: 21.3945,
    width: 9.08571,
    height: 8.32857,
    fill: "#FF8165"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16872 2.46875H21.0194C21.858 2.46875 22.544 3.02625 22.544 3.70766V8.04404C22.544 8.72554 21.858 9.28304 21.0194 9.28304H8.16872C7.33019 9.28304 6.64404 8.72554 6.64404 8.04404V3.70766C6.64404 3.02625 7.33019 2.46875 8.16872 2.46875Z",
    fill: "#A020FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3158 2.62109H20.7106C21.5195 2.62109 22.1812 3.29308 22.1812 4.11442V9.34131C22.1812 10.1628 21.5195 10.8347 20.7106 10.8347H8.3158C7.50702 10.8347 6.84521 10.1628 6.84521 9.34131V4.11442C6.84521 3.29308 7.50702 2.62109 8.3158 2.62109Z",
    stroke: "#344266",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.377 11.75V12.5054C20.377 15.3195 24.8875 15.4489 24.8875 17.8573V21.3153",
    stroke: "#344266",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.952 36.3909H6.27628C5.10296 36.3909 4.13867 35.3961 4.13867 34.1795V18.2692C4.13867 15.6923 8.23988 15.562 8.23988 12.5561V11.75",
    stroke: "#344266",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13867 19.9648H13.4271V30.0037H4.13867V19.9648Z",
    stroke: "#344266",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1877 18.0833C20.1448 17.6831 21.1979 18.1164 21.6054 19.0116L23.6836 23.5768C23.8727 23.1308 24.2374 22.7493 24.7279 22.5441L24.7283 22.5439C25.6005 22.1795 26.5807 22.4937 27.0299 23.2416C27.1762 22.6925 27.5794 22.2054 28.1579 21.9633H28.1586C29.0305 21.5993 30.0106 21.9134 30.46 22.661C30.6062 22.1119 31.0095 21.6248 31.5884 21.3829C32.5456 20.983 33.6848 21.3811 34.0061 22.3114L36.3695 29.1564C38.291 34.7222 31.4312 40.5914 26.2921 37.227L17.3777 31.3919C16.5437 30.8463 16.3524 29.7194 16.9521 28.8877C17.9011 28.4915 19.7784 28.5127 20.618 29.0625L22.3063 30.1676L18.1256 20.4659C17.7365 19.5625 18.2307 18.4835 19.1877 18.0833Z",
    stroke: "#344266",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderMedications);
export default __webpack_public_path__ + "static/media/OrderMedications.2ce28c1513abd888d686fa9646c146c0.svg";
export { ForwardRef as ReactComponent };